import { Cookies } from "react-cookie"
import Axios from 'axios'
// import { Method, ServicePath } from '../utils';

export const requestBev = (data) => {
    const cookies = new Cookies()
    const token = cookies.get('token')
    const tmp = cookies.get('tmp')
    const headers = {
        'Content-Type': 'application/json',
        'Authorization': token,
        'tmp': tmp
    }

    return new Promise( (resolve, reject) => {
        Axios({
            method: 'POST',
            url: `${process.env.REACT_APP_BEV_API_URL}`,
            headers: headers,
            // url:'https://beverestlifeapiuat.thaibevapp.com/work/v3/portal-management',
            data: data
        }).then(function (response) {
            // console.log(response)
            if(response.status === 200){
                resolve(response.data)
            }else if(response.status === 401){      
                reject(response)
            }else{
                return reject(Error(response.data.msg))
            }
        }).catch(function (error) {
            reject(error)
            console.log(error.response)           
        })
    })
}

export const requestRole = (method, path, data) => {
    //const params = data
    
    const cookies = new Cookies()
    const token = cookies.get('token')
    const tmp = cookies.get('tmp')
    const headers = {
        'Content-Type': 'application/json',
        'Authorization': token,
        'tmp': tmp
    }

    return new Promise( (resolve, reject) => {
        Axios({
            method: method,
            url: `${process.env.REACT_APP_API_URL}${path}`,
            // url:'https://beverestlifeapiuat.thaibevapp.com/work/v3/portal-management',
            headers: headers,
            data: data
        }).then(function (response) {
            // console.log(response)
            if(response.status === 200){
                resolve(response.data)
            }else if(response.status === 401){      
                reject(response)
            }else{
                return reject(Error(response.data.msg))
            }
        }).catch(function (error) {
            reject(error)
            console.log(error.response)           
        })
    })
}
export const authSign =()=>{
    const data = {
        "work":"AUTH_SIGN",
        "app_key": "ElbGQNRz20Sgqf0RkHoo1A8htVTZh6shrIwDlbYz8HqJ5fYJLavPagRNaIkkASR6vnoQBQd42M6x3okp"
    }
    return requestBev(data).then( res=>{
        return res
    }).catch(err=>{
        return err
    })
}
export const reqSerchUserByText =(data)=>{
    return requestBev(data).then( res=>{
        return res
    }).catch(err=>{
        return err
    })
}

// export const createRole =(data)=>{
//     return requestRole(Method.POST, ServicePath.RoleCreate,data).then( res=>{
//         return res
//     }).catch(err=>{
//         return err
//     })
// }


// export const listNoti =()=>{
//     const data = {
//         "work": "FEED_NOTIFICATION",
//         "item_per_request": 20,
//         "current_item_amount":0
//      }
     
//     return requestNoti(data).then( res=>{
//         return res
//     }).catch(err=>{
//         return err
//     })
// }

// export const listDrawer =()=>{
//     const data = {
//         "work": "DRAWER_NOTIFICATION.FEED",
//         "item_per_request": 20,
//         "current_item_amount":0
//      }
     
//     return requestNoti(data).then( res=>{
//         return res
//     }).catch(err=>{
//         return err
//     })
// }

// export const displayTypes =()=>{
//     const data = {
//         "work": "DRAWER_NOTIFICATION.GET_CREATION_TEMPLATE"
//      }
     
//     return requestNoti(data).then( res=>{
//         return res
//     }).catch(err=>{
//         return err
//     })
// }
// export const upload=(data)=>{
//     try {
//         const res = Axios.post('http://thana.xyz:4001/work', data, {
//             headers: {
//                 'Content-Type': 'application/json'
//             }
//         })
//         return res
//     } catch (err) {
//         console.log(err)
//     }
// }

// export const logSendNoti =(data)=>{
//     return logRequest('POST', ServicePath.LogSendNoti, data).then( res=>{
//         console.log(res)
//         return res
//     }).catch(err=>{
//         console.log(err)
//         return err
//     })
// }